module.exports = __webpack_public_path__ + "media/img/private-venue/banner-main-c3d80bba3a874eb21d40dc6fce83d5bb.png";